var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacilityEntertainment = function SvgFacilityEntertainment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m59-200 79.245-560H823l78 560H773L643-330H317L187-200zm97-55 134.705-135H669l135 135h29l-63.21-445H190l-63 445zm544-185q16 0 28-12t12-28-12-28-28-12-28 12-12 28 12 28 28 12m-85-130q16 0 28-12t12-28-12-28-28-12-28 12-12 28 12 28 28 12M300-445h50v-75h75v-50h-75v-75h-50v75h-75v50h75zm180-33"
  })));
};
export default SvgFacilityEntertainment;